import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { fetch } from '@nx/angular';
import * as MagayaNetworkConfigurationActions from './magaya-network-configuration.actions';
import { MagayaNetworkConfigurationService } from '../magaya-network-configuration.service';
import { map } from 'rxjs/operators';

@Injectable()
export class MagayaNetworkConfigurationEffects {
    init$ = createEffect(() =>
        this.actions$.pipe(
            ofType(MagayaNetworkConfigurationActions.init),
            fetch({
                run: action => {
                    return this.service
                        .show(action.organization.id)
                        .pipe(
                            map(magayaNetworkConfiguration =>
                                MagayaNetworkConfigurationActions.loadMagayaNetworkConfigurationSuccess(
                                    { magayaNetworkConfiguration }
                                )
                            )
                        );
                },

                onError: (action, error) => {
                    if (error.status === 404) {
                        return MagayaNetworkConfigurationActions.loadMagayaNetworkConfigurationSuccess(
                            { magayaNetworkConfiguration: null }
                        );
                    }
                    console.error('Error', error);
                    return MagayaNetworkConfigurationActions.loadMagayaNetworkConfigurationFailure(
                        { error }
                    );
                },
            })
        )
    );

    create$ = createEffect(() =>
        this.actions$.pipe(
            ofType(
                MagayaNetworkConfigurationActions.createMagayaNetworkConfiguration
            ),
            fetch({
                run: action => {
                    return this.service
                        .create(action.payload)
                        .pipe(
                            map(magayaNetworkConfiguration =>
                                MagayaNetworkConfigurationActions.createMagayaNetworkConfigurationSuccess(
                                    { magayaNetworkConfiguration }
                                )
                            )
                        );
                },

                onError: (action, error) => {
                    console.error('Error', error);
                    return MagayaNetworkConfigurationActions.createMagayaNetworkConfigurationFailure(
                        { error }
                    );
                },
            })
        )
    );

    update$ = createEffect(() =>
        this.actions$.pipe(
            ofType(
                MagayaNetworkConfigurationActions.updateMagayaNetworkConfiguration
            ),
            fetch({
                run: action => {
                    return this.service
                        .update(action.entity, action.payload)
                        .pipe(
                            map(magayaNetworkConfiguration =>
                                MagayaNetworkConfigurationActions.updateMagayaNetworkConfigurationSuccess(
                                    { magayaNetworkConfiguration }
                                )
                            )
                        );
                },

                onError: (action, error) => {
                    console.error('Error', error);
                    return MagayaNetworkConfigurationActions.updateMagayaNetworkConfigurationFailure(
                        { error }
                    );
                },
            })
        )
    );

    test$ = createEffect(() =>
        this.actions$.pipe(
            ofType(
                MagayaNetworkConfigurationActions.testMagayaNetworkConfiguration
            ),
            fetch({
                run: action => {
                    return this.service
                        .test(action.organization.id)
                        .pipe(
                            map(magayaNetworkConfiguration =>
                                MagayaNetworkConfigurationActions.testMagayaNetworkConfigurationSuccess(
                                    { magayaNetworkConfiguration }
                                )
                            )
                        );
                },

                onError: (action, error) => {
                    console.error('Error', error);
                    return MagayaNetworkConfigurationActions.testMagayaNetworkConfigurationFailure(
                        { error }
                    );
                },
            })
        )
    );

    constructor(
        private actions$: Actions,
        private service: MagayaNetworkConfigurationService
    ) {}
}
